const LocaleText = {
  pagination: {
    // Root
    noRowsLabel: 'የፈለጉት አልተገኘም !',
    noResultsOverlayLabel: 'ምንም ውጤት አልተገኘም !',

    // Density selector toolbar button text
    toolbarDensity: 'ጥልቀት',
    toolbarDensityLabel: 'ጠባብ',
    toolbarDensityCompact: 'ትንሽ',
    toolbarDensityStandard: 'መካክለኛ',
    toolbarDensityComfortable: 'ትልቅ',

    // Columns selector toolbar button text
    toolbarColumns: 'ዓምዶች',
    toolbarColumnsLabel: 'አምዶችን ይምረጡ',

    // Filters toolbar button text
    toolbarFilters: 'ማጣሪያዎች',
    toolbarFiltersLabel: 'ማጣሪያዎችን አሳይ',
    toolbarFiltersTooltipHide: 'ማጣሪያዎችን ይደብቁ',
    toolbarFiltersTooltipShow: 'ማጣሪያዎችን አሳይ',
    toolbarFiltersTooltipActive: (count) => (count !== 1 ? `${count} ንቁ ማጣሪያዎች` : `${count} ንቁ ማጣሪያ`),

    // Quick filter toolbar field
    toolbarQuickFilterPlaceholder: 'ፍለጋ…',
    toolbarQuickFilterLabel: 'ፍለጋ',
    toolbarQuickFilterDeleteIconLabel: 'ግልጽ',

    // Export selector toolbar button text
    toolbarExport: 'ኤክስፖርት',
    toolbarExportLabel: 'ኤክስፖርት',
    toolbarExportCSV: 'እንደ CSV አውርድ',
    toolbarExportPrint: 'ህትመት',
    toolbarExportExcel: 'እንደ Excel አውርድ',

    // Columns panel text
    columnsPanelTextFieldLabel: 'አምድ ፈልግ',
    columnsPanelTextFieldPlaceholder: 'የዓምድ ርዕስ',
    columnsPanelDragIconLabel: 'የመልሶ ማዘዣ አምድ',
    columnsPanelShowAllButton: 'ሁሉንም አሳይ',
    columnsPanelHideAllButton: 'ሁሉን ደብቅ',

    // Filter panel text
    filterPanelAddFilter: 'ማጣሪያ ጨምር',
    filterPanelRemoveAll: 'ሁሉንም አስወግድ',
    filterPanelDeleteIconLabel: 'አጥፉ',
    filterPanelLogicOperator: 'ሎጂክ ኦፕሬተር',
    filterPanelOperator: 'ኦፕሬተር',
    filterPanelOperatorAnd: 'እና',
    filterPanelOperatorOr: 'ወይም',
    filterPanelColumns: 'ዓምዶች',
    filterPanelInputLabel: 'ዋጋ',
    filterPanelInputPlaceholder: 'የማጣሪያ ዋጋ',

    // Filter operators text
    filterOperatorContains: 'ይይዛል',
    filterOperatorEquals: 'እኩል ነው',
    filterOperatorStartsWith: 'የሚጀምረው',
    filterOperatorEndsWith: 'መጨረሻው',
    filterOperatorIs: 'ለ',
    filterOperatorNot: 'አይደለም',
    filterOperatorAfter: 'በኋላ',
    filterOperatorOnOrAfter: 'ላይ ወይም በኋላ',
    filterOperatorBefore: 'በፊት ነው',
    filterOperatorOnOrBefore: 'ላይ ወይም በፊት',
    filterOperatorIsEmpty: 'ባዶ ነው',
    filterOperatorIsNotEmpty: 'ባዶ አይደለም',
    filterOperatorIsAnyOf: 'አንደኛው',

    // Filter values text
    filterValueAny: 'ማንኛውም',
    filterValueTrue: 'እውነት',
    filterValueFalse: 'ሐሰት',

    // Column menu text
    columnMenuLabel: 'ሜኑ',
    columnMenuShowColumns: 'ዓምዶች አሳይ',
    columnMenuManageColumns: 'አምዶችን ያስተዳድር',
    columnMenuFilter: 'ማጣሪያ',
    columnMenuHideColumn: 'አምድ ይደብቁ',
    columnMenuUnsort: 'ያልተደላደለ',
    columnMenuSortAsc: 'ወደ ላይ በቅደም ተከተል ለይ',
    columnMenuSortDesc: 'በመውረድ ቅደም ተከተል ይለዩ',

    // Column header text
    columnHeaderFiltersTooltipActive: (count) => (count !== 1 ? `${count} ንቁ ማጣሪያዎች` : `${count} active filter`),
    columnHeaderFiltersLabel: 'ማጣሪያዎችን አሳይ',
    columnHeaderSortIconLabel: 'በቅደም ተከተል',

    // Rows selected footer text
    footerRowSelected: (count) =>
      count !== 1 ? `${count.toLocaleString()} ረድፎች ተመረጡ` : `${count.toLocaleString()} ረድፍ ተመረጠ`,

    // Total row amount footer text
    footerTotalRows: 'ጠቅላላ ረድፍ:',

    labelRowsPerPage: 'ጠቅላላ ረድፍ:',

    // Total visible row amount footer text
    footerTotalVisibleRows: (visibleCount, totalCount) =>
      `${visibleCount.toLocaleString()} of ${totalCount.toLocaleString()}`,

    // Checkbox selection text
    checkboxSelectionHeaderName: 'የCheckbox ምርጫ',
    checkboxSelectionSelectAllRows: 'ሁሉንም ረድፍ ይምረጡ',
    checkboxSelectionUnselectAllRows: 'ሁሉንም ረድፍ አይምረጡ',
    checkboxSelectionSelectRow: 'ረድፍ ይምረጡ',
    checkboxSelectionUnselectRow: 'ረድፍ አይምረጡ',

    // Boolean cell text
    booleanCellTrueLabel: 'አዎ',
    booleanCellFalseLabel: 'አይደለም',

    // Actions cell more text
    actionsCellMore: 'ተጨማሪ',

    // Column pinning text
    pinToLeft: 'ወደ ግራ ውሰድ',
    pinToRight: 'ወደ ቀኝ ውሰድ',
    unpin: 'ወደ ቦታው መልስ',

    // Tree Data
    treeDataGroupingHeaderName: 'ቡድን',
    treeDataExpand: 'ልጆች ይመልከቱ',
    treeDataCollapse: 'ልጆችን መደበቅ',

    // Grouping columns
    groupingColumnHeaderName: 'ቡድን',
    groupColumn: (name) => `በቡድን ${name}`,
    unGroupColumn: (name) => `በቡድን መሰብሰብን አቁም ${name}`,

    // Master/detail
    detailPanelToggle: 'ዝርዝር ፓነል ልጥፍ',
    expandDetailPanel: 'አስፋው',
    collapseDetailPanel: 'አጥበው',

    // Used core components translation keys
    MuiTablePagination: {},

    // Row reordering text
    rowReorderingHeaderName: 'ረድፍ ከንደገና ቅደም ተከተል',

    // Aggregation
    aggregationMenuItemHeader: 'አሰባሰብ',
    aggregationFunctionLabelSum: 'ድምር',
    aggregationFunctionLabelAvg: 'አማካይ',
    aggregationFunctionLabelMin: 'ትንሽ',
    aggregationFunctionLabelMax: 'ትልቅ',
    aggregationFunctionLabelSize: 'መጠኖች',
  },
};

export default LocaleText;
